module.exports = __webpack_public_path__ + "static/media/1.cd0f9188.png";